module.exports = __webpack_public_path__ + "img/telecloud-logo.9c7f6046.png";